"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SaphanasystemGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    fillRule: "evenodd",
    clipPath: "url(#prefix__saphanasystem-grey-outline__clip0_19770_5442)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h10v1h1V1a1 1 0 00-1-1H1a1 1 0 00-1 1v10a1 1 0 001 1h1v-1H1V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3H3v1.5h1.5V3zM3 2a1 1 0 00-1 1v1.5a1 1 0 001 1h1.5a1 1 0 001-1V3a1 1 0 00-1-1H3zM4.5 13.5H3V15h1.5v-1.5zm-1.5-1a1 1 0 00-1 1V15a1 1 0 001 1h1.5a1 1 0 001-1v-1.5a1 1 0 00-1-1H3zM15 3h-1.5v1.5H15V3zm-1.5-1a1 1 0 00-1 1v1.5a1 1 0 001 1H15a1 1 0 001-1V3a1 1 0 00-1-1h-1.5zM15 13.5h-1.5V15H15v-1.5zm-1.5-1a1 1 0 00-1 1V15a1 1 0 001 1H15a1 1 0 001-1v-1.5a1 1 0 00-1-1h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.021 11.404l1.266 1.266-.619.619-1.28-1.28c.322-.172.545-.379.633-.605zM6.61 5.992L5.244 4.627l-.619.618 1.353 1.353c.087-.227.31-.434.631-.606zM5.957 11.338L4.625 12.67l.619.619 1.31-1.311c-.32-.182-.533-.402-.597-.64zm5.376-5.376c.322.163.554.359.662.575l1.292-1.292-.619-.618-1.335 1.335z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.638 5.425C7.268 5.155 8.103 5 9 5s1.732.155 2.363.425c.314.134.6.308.815.525.217.22.384.512.384.862v4.375c0 .35-.167.643-.384.863-.215.217-.501.39-.816.525-.63.27-1.465.425-2.362.425s-1.732-.155-2.362-.425a2.558 2.558 0 01-.816-.525c-.217-.22-.385-.512-.385-.863V6.814c0-.35.168-.643.385-.863.215-.217.501-.39.816-.525zm-.2 2.682V9c0 .012.003.066.096.16.095.096.257.206.497.309.479.205 1.174.344 1.969.344.795 0 1.49-.14 1.969-.345.24-.102.402-.212.497-.308.093-.094.097-.148.097-.16v-.893a3.519 3.519 0 01-.2.093c-.63.27-1.466.425-2.363.425S7.268 8.47 6.638 8.2a3.494 3.494 0 01-.2-.093zm5.125-1.294c0 .012-.004.065-.097.16a1.584 1.584 0 01-.497.308c-.479.205-1.174.344-1.969.344-.795 0-1.49-.139-1.969-.344a1.583 1.583 0 01-.497-.309c-.093-.094-.096-.147-.096-.16 0-.012.003-.065.096-.16.095-.095.257-.205.497-.308C7.51 6.139 8.205 6 9 6c.795 0 1.49.139 1.969.344.24.103.402.213.497.309.093.094.097.147.097.16zm0 3.481a3.583 3.583 0 01-.2.094c-.63.27-1.466.425-2.363.425s-1.732-.155-2.362-.425a3.557 3.557 0 01-.2-.094v.893c0 .013.003.066.096.16.095.097.257.206.497.309C7.51 11.861 8.205 12 9 12c.795 0 1.49-.139 1.969-.344.24-.103.402-.213.497-.309.093-.094.097-.147.097-.16v-.893z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__saphanasystem-grey-outline__clip0_19770_5442"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SaphanasystemGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SaphanasystemGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SaphanasystemGreyOutline;
exports["default"] = _default;